<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <oxd-dialog
    :style="{width: '90%', maxWidth: '560px'}"
    @update:show="onCancel"
  >
    <div class="orangehrm-modal-header">
      <oxd-text type="card-title">
        {{ $t('time.approve_pending_title') }}
      </oxd-text>
    </div>
    <oxd-divider />

    <div class="pending-leave-dialog-body">
      <oxd-text tag="p">
        {{ eligible }} {{ $t('time.pending_leave_count') }}
      </oxd-text>

      <table v-if="items.length > 0" class="pending-leave-table">
        <thead>
          <tr>
            <th>{{ $t('general.employee') }}</th>
            <th>{{ $t('general.date') }}</th>
            <th>{{ $t('leave.leave_type') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.employeeName }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.leaveType }}</td>
          </tr>
        </tbody>
      </table>

      <oxd-text
        v-if="eligible > items.length"
        tag="p"
        class="pending-leave-more"
      >
        + {{ eligible - items.length }}
      </oxd-text>
    </div>

    <oxd-divider />
    <oxd-form-actions class="orangehrm-form-action">
      <oxd-button
        display-type="ghost"
        :label="$t('general.cancel')"
        @click="onCancel"
      />
      <oxd-button
        display-type="secondary"
        :label="$t('time.approve_all_pending')"
        :disabled="isLoading"
        @click="onConfirm"
      />
    </oxd-form-actions>
  </oxd-dialog>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';

export default {
  name: 'ApprovePendingLeaveDialog',

  components: {
    'oxd-dialog': OxdDialog,
  },

  props: {
    eligible: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close', 'confirm'],

  methods: {
    onCancel() {
      this.$emit('close');
    },
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
.pending-leave-dialog-body {
  padding: 0.75rem 0;
  max-height: 320px;
  overflow-y: auto;
}

.pending-leave-table {
  width: 100%;
  margin-top: 0.75rem;
  border-collapse: collapse;
  font-size: 0.8rem;

  th,
  td {
    text-align: left;
    padding: 0.35rem 0.5rem;
    border-bottom: 1px solid #e0e0e0;
  }

  th {
    font-weight: 600;
  }
}

.pending-leave-more {
  margin-top: 0.5rem;
  font-size: 0.8rem;
  font-style: italic;
}
</style>
